"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumNetLabelGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const project_1 = require("../../project");
class AltiumNetLabelGroupingRule {
    constructor(config) {
        this.config = config;
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
        if (this.config.mode !== project_1.HierarchyMode.Global) {
            throw new Error(`AltiumNetLabelGroupingRule should only be used in Global mode. ` +
                `In other modes, net labels are local to their sheet.`);
        }
    }
    apply(manager, hierarchy) {
        this.mergeNetLabelsGlobally(manager, hierarchy);
        return manager;
    }
    mergeNetLabelsGlobally(manager, hierarchy) {
        const netLabelGroups = new Map();
        for (const group of manager.findGroupsWithLabel('net-label')) {
            const netLabels = group.getNetLabels().filter((label) => label.labelType === 'net-label');
            for (const label of netLabels) {
                const netLabelName = label.formattedLabel;
                if (!netLabelName) {
                    continue;
                }
                if (!netLabelGroups.has(netLabelName)) {
                    netLabelGroups.set(netLabelName, new Set());
                }
                netLabelGroups.get(netLabelName).add(group);
            }
        }
        for (const groups of netLabelGroups.values()) {
            if (groups.size <= 1) {
                continue;
            }
            const groupsArray = Array.from(groups);
            manager.mergeGroups(...groupsArray);
        }
        for (const child of hierarchy.children) {
            this.mergeNetLabelsGlobally(manager, child);
        }
    }
}
exports.AltiumNetLabelGroupingRule = AltiumNetLabelGroupingRule;
//# sourceMappingURL=AltiumNetLabelGroupingRule.js.map